import type { UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import apiBase from "../../utils/apiBase";

export interface INews {
  content: string;
  id: string;
  postedAt: string;
  title: string;
  url?: string;
}

const fetchNewsCount = async (fromDate: Date | null): Promise<any> => {
  return await apiBase.get(`/news/count`, {
    params: {
      fromDate: fromDate,
      toDate: new Date(Date.now()),
    },
  });
};

const fetchNews = async (): Promise<INews[]> => {
  return await apiBase.get(`/news`);
};

export const useNewsCount = (
  fromDate: Date | null,
): UseQueryResult<number, unknown> => {
  return useQuery(["newsCount"], () => fetchNewsCount(fromDate));
};

export const useNews = (): UseQueryResult<INews[], unknown> => {
  return useQuery(["news"], () => fetchNews());
};
